module.exports = __webpack_public_path__ + "img/app-store.8e66bac6.svg";